import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { BREAKPOINTS } from '../utilities/index';

(function () {
  'use strict';

  class SliderMemberList {
    constructor(wrap) {
      this.wrap = wrap;
      this.el_sw = this.wrap.querySelector('.swiper');
      this.el_sw_wrap = this.wrap.querySelector('.swiper-wrapper');

      const next = this.wrap.querySelector('.swiper-button-next');
      const prev = this.wrap.querySelector('.swiper-button-prev');
      const page = this.wrap.querySelector('.swiper-pagination');

      // data
      const wideSlidesPerView = this.wrap.dataset.wideSlidesPerView?Number(this.wrap.dataset.wideSlidesPerView):3;

      this.swiper = new Swiper(this.el_sw, {
        modules: [Navigation, Pagination],
        loop: false,
        slidesPerView: 1.32,
        slidesPerGroup: 1,
        spaceBetween: 25,
        breakpoints: {
          [BREAKPOINTS.desktop]: {
            slidesPerView: 2,
            //slidesPerGroup: 2,
            spaceBetween: 24,
          },
          [BREAKPOINTS.wide]: {
            slidesPerView: wideSlidesPerView,
            //slidesPerGroup: wideSlidesPerView,
            spaceBetween: 48,
          }
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        pagination: {
          el: page,
          type: "fraction",
        },
      });
    }

  }
  // init //--------//
  document.querySelectorAll('.c-sliderMemberList').forEach((wrap) => {
    new SliderMemberList(wrap)
  });

})();